import React, { useState, useEffect } from "react";
import { AlertCircle, Clock, BarChart2 } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";

const AITokenLimitTracker = ({ isDarkTheme, isVisible, resetTime }) => {
  const [timeRemaining, setTimeRemaining] = useState("");

  useEffect(() => {
    const updateTimeDisplay = () => {
      const now = new Date();
      const tomorrow = new Date();
      tomorrow.setDate(tomorrow.getDate() + 1);
      tomorrow.setHours(resetTime?.hours || 0, resetTime?.minutes || 0, 0, 0);

      const timeDiff = tomorrow - now;

      if (timeDiff <= 0) {
        setTimeRemaining("any moment");
        return;
      }

      const hours = Math.floor(timeDiff / (1000 * 60 * 60));
      const minutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));

      if (hours > 0) {
        setTimeRemaining(`${hours}h ${minutes}m`);
      } else {
        setTimeRemaining(`${minutes}m`);
      }
    };

    updateTimeDisplay();
    const interval = setInterval(updateTimeDisplay, 60000);

    return () => clearInterval(interval);
  }, [resetTime]);

  const tomorrow = new Date();
  tomorrow.setDate(tomorrow.getDate() + 1);
  const tomorrowDate = tomorrow.toLocaleDateString([], {
    month: 'short',
    day: 'numeric'
  });

  const formattedResetTime = `${resetTime?.hours || 0}:${String(resetTime?.minutes || 0).padStart(2, '0')}`;

  if (!isVisible) return null;

  return (
    <AnimatePresence>
      <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        exit={{ opacity: 0, y: -10 }}
        transition={{ duration: 0.2 }}
        className={`w-[98%] md:w-[80%] mx-auto mb-2 rounded-lg overflow-hidden shadow-md border-l-4 ${
          isDarkTheme
            ? 'bg-gray-800/95 border-amber-500 text-gray-200'
            : 'bg-amber-50 border-amber-500 text-gray-800'
        } transition-all duration-200 ease-in-out`}
      >
        <div className="flex items-center py-2 px-4 gap-3">
          <div className={`p-2 rounded-lg ${isDarkTheme ? 'bg-gray-700/50' : 'bg-amber-50'}`}>
            <AlertCircle className="w-5 h-5 text-amber-500" />
          </div>

          <div className="flex-1">
            <div className="flex items-center justify-between">
              <p className="text-sm font-semibold">AI Token Limit Reached</p>
              <div className="flex items-center text-xs">
                <Clock className="w-4 h-4 mr-1 text-amber-500" />
                <span>Resets in <span className="font-medium">{timeRemaining}</span></span>
              </div>
            </div>

            <p className={`text-xs ${isDarkTheme ? 'text-gray-300' : 'text-gray-600'} mt-0.5`}>
              AI responses will resume on {tomorrowDate} at {formattedResetTime}
            </p>
          </div>

        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default AITokenLimitTracker;